import { render, staticRenderFns } from "./SailDetail.vue?vue&type=template&id=1d372705&scoped=true&"
import script from "./SailDetail.vue?vue&type=script&lang=js&"
export * from "./SailDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d372705",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d372705')) {
      api.createRecord('1d372705', component.options)
    } else {
      api.reload('1d372705', component.options)
    }
    module.hot.accept("./SailDetail.vue?vue&type=template&id=1d372705&scoped=true&", function () {
      api.rerender('1d372705', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/sail/SailDetail.vue"
export default component.exports